import { useNavigate, useLocation, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { createElement, Fragment, useEffect, useRef } from "react";
import { clearGuestLesson } from "@/lib/aiSession";
import routes from "./config";
import RouteMetadata from "@/pages/public/RouteMetadata";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);
  useEffect(() => {
    if (previousPath.current.startsWith("/scan/result") &&
        !pathname.startsWith("/scan/result")) clearGuestLesson();
    previousPath.current = pathname;
  }, [pathname]);
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return createElement(Fragment, null, createElement(RouteMetadata), element);
}
